import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MenuGuard } from '../app/guard/menu.guard';
// Import Containers
import {
  FullLayoutComponent,
  SimpleLayoutComponent
} from './containers';


export const routes: Routes = [
  {
    path: '',
    redirectTo: 'thongketrangthai/thongkechatluong',
    pathMatch: 'full',
  },
  {
    path: '',
    component: FullLayoutComponent,
    data: {
      title: 'bread-home'
    },
    children: [
      {
        path: 'canhbao',
        loadChildren: './views/canhbao/canhbao.module#CanhBaoModule',
      },

      {
        path: 'canhbaotonthat',
        loadChildren: './views/canh-bao-ton-that/canhbaotonthat.module#CanhBaoTonThatModule',
      },
      {
        path: 'thongketrangthai',
        loadChildren: './views/thong-ke-trang-thai/thongketrangthai.module#ThongKeTrangThaiModule',
      },
      {
        path: 'quanly',
        loadChildren: './views/quan-ly/quanly.module#QuanLyModule',
      },
      {
        path: 'giamsat',
        loadChildren: './views/giam-sat/giamsat.module#GiamSatModule',
      },
      {
        path: 'baocao',
        loadChildren: './views/bao-cao/baocao.module#BaoCaoModule',
      },
      {
        path: 'tienich',
        loadChildren: './views/tien-ich/tienich.module#TienIchModule',
      },
      {
        path: 'ghichiso',
        loadChildren: './views/ghi-chi-so/ghichiso.module#GhiChiSoModule',
      },
      {
        path: 'nhapthongtinkh',
        loadChildren: './views/nhap-thong-tin-kh/nhapthongtinkh.module#NhapThongTinKHModule',
      },
      
      {
        path: 'timkiem',
        loadChildren: './views/tim-kiem/timkiem.module#TimKiemModule',
      },
      {
        path: 'canhbao',
        loadChildren: './views/canhbao/canhbao.module#CanhBaoModule',
      },

    ]
  },
  {
    path: 'pages',
    component: SimpleLayoutComponent,
    data: {
      title: 'pages'
    },
    children: [
      {
        path: '',
        loadChildren: './views/pages/pages.module#PagesModule',
      }
    ]
  }
 
];


@NgModule({
  imports: [ RouterModule.forRoot(routes) ],
  exports: [ RouterModule ]
})

export class AppRoutingModule {


}



// WEBPACK FOOTER //
// /media/tranhien/34DCFEAFDCFE6B0E/SourceCode/AMISS4/AMISS4_PC1_LINUX/src/app/app.routing.ts